(function (scope) {
  'use strict';
  const products = [
    ['pep',46740550418606,0,'pepperoni_3f8d24e7-d8ba-4a2b-ac73-fe40ec5f5eaf.jpg'],
    ['sau',46740550451374,0,'sausage_44c46af5-9715-41c5-9d7c-c9df01603b09.jpg'],
    ['che',46740550484142,0,'cheese_60b7ed92-2bc9-463d-bd4d-a2fae2e59404.jpg'],
    ['spi',46740550516910,0,'spinach_b865e045-2f48-4fd8-b847-710e2bea24b3.jpg'],
    ['meat',47041624441006,1000,'meat-and-more_6a1b1dce-4f93-4694-9555-6398f0a40787.jpg'],
    ['beef',46953544843438,1000,'italian_beef_4.jpg'],
    ['combo',48958363041966,1000,'GIO01ITCOMBO-italian-combo-square_a6db1959-b588-4896-880f-a1f182500f47.jpg'],
    ['pit',48958363074734,1000,'pitmaster_4.jpg'],
    ['da',48958363107502,1000,'da_pizza_4.jpg']
  ].map(([id,variantId,upcharge,image]) => ({id,variantId,upcharge,image}));
  const giftIds = ['sauce','season','relish'];
  function total(quantities) {
    if (!quantities || Object.keys(quantities).some(id => !products.some(p => p.id === id))) throw new Error('Unknown pizza');
    let count=0, upgrades=0;
    products.forEach(p => {
      const q=quantities[p.id] ?? 0;
      if (!Number.isSafeInteger(q) || q<0) throw new Error('Invalid quantity');
      count+=q; upgrades+=q*p.upcharge;
    });
    if (count>6) throw new Error('Six pizza maximum');
    return {count,upgrades,cents:16599+upgrades,complete:count===6};
  }
  function giftFromIndex(index) {
    if (!Number.isSafeInteger(index) || index<0 || index>=giftIds.length) throw new Error('Invalid gift');
    const id=giftIds[index];
    return {id,quantity:id==='sauce'?3:1};
  }

  const giftVariants={sauce:46702754857134,season:47723071176878,relish:46702753972398};
  function cartItem(quantities,gift,parents) {
    const state=total(quantities);
    if(!state.complete || !giftIds.includes(gift?.id))throw new Error('Complete your six pizzas and reveal your gift first.');
    const expectedGift=giftFromIndex(giftIds.indexOf(gift.id));
    if(gift.quantity!==expectedGift.quantity)throw new Error('Invalid gift quantity');
    const parent=parents.find(p=>p.gift===gift.id && p.premium===state.upgrades/1000);
    if(!parent?.available || parent.price!==state.cents)throw new Error('This box is temporarily unavailable. Please try again shortly.');
    // Follow the existing BYOB rounding convention: one unit absorbs the pennies.
    const unitCents=Math.round(state.cents/6), components=[], properties={};
    let running=0,index=1;
    products.filter(p=>quantities[p.id]).forEach(p=>{
      const quantity=quantities[p.id];components.push({id:p.variantId,quantity,price:unitCents/100});running+=unitCents*quantity;
      for(let n=0;n<quantity;n++)properties['Item '+index++]=p.id;
    });
    const difference=state.cents-running;
    if(difference){const last=components[components.length-1];if(last.quantity>1){last.quantity--;components.push({id:last.id,quantity:1,price:(unitCents+difference)/100});}else last.price=(unitCents+difference)/100;}
    components.push({id:giftVariants[gift.id],quantity:gift.quantity,price:0,attributes:{'Mystery Gift':'FREE'}});
    return {id:Number(parent.id),quantity:1,properties:{...properties,_components:JSON.stringify(components),_settings:JSON.stringify({title:'Halloween Six-Pizza Box + Mystery Gift'}),_campaign:'halloween-mystery-2026',_pack_size:'6','Mystery Gift':gift.id}};
  }

  const api={products,total,giftFromIndex,cartItem};
  if (typeof module!=='undefined' && module.exports) module.exports=api;
  if (!scope.document) return;
  function mount(root) {
    if (root.dataset.halloweenMounted) return;
    root.dataset.halloweenMounted='true';
    const config=JSON.parse(root.querySelector('[data-hg-config]').textContent);
    const t=config.text, q=Object.fromEntries(products.map(p=>[p.id,0]));
    const find=name=>root.querySelector('[data-hg-'+name+']');
    const currency=new Intl.NumberFormat(config.locale || 'en-US',{style:'currency',currency:config.currency || 'USD'});
    const money=cents=>currency.format(cents/100);
    const cdn='https://ship.giordanos.com/cdn/shop/files/';
    const storageKey='giordanos:halloween-six-gift:2026:v1';
    // Assignment persists, but disclosure requires an explicit click on each page load.
    let gift=null,savedGift=null,filter='all',revealing=false,submitting=false;
    try { const saved=scope.localStorage.getItem(storageKey); if (giftIds.includes(saved) && config.giftAvailability?.[saved]!==false) savedGift=giftFromIndex(giftIds.indexOf(saved)); } catch (_) {}
    function el(tag,className,text) {const n=document.createElement(tag);if(className)n.className=className;if(text!==undefined)n.textContent=text;return n;}
    products.forEach(p=>{
      const card=el('article','hg-card');card.dataset.kind=p.upcharge?'specialty':'classic';
      const img=el('img');img.src=cdn+p.image+'?width=900';img.alt=t[p.id];img.width=900;img.height=600;img.loading='lazy';
      if(['beef','pit','da'].includes(p.id))img.classList.add('hg-full-pizza');
      const body=el('div','hg-card-body');body.append(el('h3','',t[p.id]),el('p','hg-card-note',p.upcharge?'+$10':t.included));
      const controls=el('div','hg-qty');
      [-1,1].forEach(delta=>{const b=el('button','',delta<0?'−':'+');b.type='button';b.dataset.pizza=p.id;b.dataset.delta=delta;b.setAttribute('aria-label',(delta<0?t.remove:t.add)+' '+t[p.id]);controls.append(b);if(delta<0){const output=el('output','',0);output.dataset.quantity=p.id;output.setAttribute('aria-label',t[p.id]+' '+t.quantity);controls.append(output);}});
      body.append(controls);card.append(img,body);find('pizzas').append(card);
    });
    function move(name){find(name).scrollIntoView({behavior:scope.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
    function updateGift() {
      if(!gift){
        find('reveal').hidden=false;find('gift-result').hidden=true;
        find('gift-summary').textContent=t.unrevealed;
        return;
      }
      find('reveal').hidden=true;find('gift-result').hidden=false;
      find('gift-name').textContent=t[gift.id];find('gift-copy').textContent=t[gift.id+'Copy'];
      find('gift-summary').textContent=t[gift.id];
      const photos=find('gift-photos');
      if(photos.dataset.gift!==gift.id){
        photos.replaceChildren();photos.dataset.gift=gift.id;
        photos.classList.toggle('is-three',gift.quantity===3);
        if(config.images[gift.id]) for(let i=0;i<gift.quantity;i++){
          const image=el('img');image.src=config.images[gift.id];image.alt=i===0?t[gift.id]:'';
          image.width=230;image.height=180;photos.append(image);
        }
      }
      const token=find('jump-gift');
      token.querySelector('span').textContent=t.revealed;
      token.setAttribute('aria-label',t.revealed+' '+t[gift.id]);
      find('gift-status').textContent=t.revealed+' '+t[gift.id];
      find('gift-region').classList.add('is-revealed');
    }
    function update() {
      const state=total(q);
      root.querySelectorAll('[data-hg-total]').forEach(n=>n.textContent=money(state.cents));
      root.querySelectorAll('[data-hg-progress]').forEach(n=>n.textContent=state.count+'/6');
      root.querySelectorAll('[data-hg-progress-label]').forEach(n=>n.textContent=state.count+' of 6 selected');
      root.querySelectorAll('.hg-card').forEach((card,i)=>card.classList.toggle('is-selected',q[products[i].id]>0));
      find('finish').textContent=state.complete?t.review:t.backToPizzas;
      find('upgrade').textContent=money(state.upgrades);
      find('items').replaceChildren();
      if(!state.count)find('items').append(el('li','hg-empty',t.empty));
      products.filter(p=>q[p.id]).forEach(p=>{
        const li=el('li');li.append(el('span','',q[p.id]+' × '+t[p.id]));
        const b=el('button','hg-remove','−');b.type='button';b.dataset.pizza=p.id;b.dataset.delta=-1;b.setAttribute('aria-label',t.remove+' '+t[p.id]);li.append(b);find('items').append(li);
      });
      root.querySelectorAll('[data-pizza]').forEach(b=>b.disabled=Number(b.dataset.delta)>0?state.count===6:q[b.dataset.pizza]===0);
      root.querySelectorAll('[data-pizza]').forEach(b=>{const p=products.find(p=>p.id===b.dataset.pizza);if(Number(b.dataset.delta)>0 && config.availability?.[p.variantId]===false)b.disabled=true;});
      root.querySelectorAll('[data-quantity]').forEach(n=>n.textContent=q[n.dataset.quantity]);
      const label=!state.complete?t.pickSix:!gift?t.revealCta:t.review;
      root.querySelectorAll('[data-hg-next]').forEach(b=>b.textContent=label);
      find('selection-status').textContent=state.complete?t.sixReady:t.selectMore.replace('{n}',String(6-state.count));
      updateGift();
    }
    root.addEventListener('click',event=>{
      const b=event.target.closest('[data-pizza]');if(!b||b.disabled||!root.contains(b))return;
      const delta=Number(b.dataset.delta),id=b.dataset.pizza;
      if(!Object.hasOwn(q,id)||![-1,1].includes(delta))return;
      const next={...q,[id]:q[id]+delta};
      try{total(next);}catch(_){return;}
      q[id]=next[id];update();
    });
    root.querySelectorAll('[data-hg-filter]').forEach(b=>b.addEventListener('click',()=>{
      filter=b.dataset.hgFilter;
      root.querySelectorAll('[data-hg-filter]').forEach(n=>n.setAttribute('aria-pressed',String(n===b)));
      root.querySelectorAll('.hg-card').forEach(c=>c.hidden=filter!=='all'&&c.dataset.kind!==filter);
    }));
    function revealGift(){
      if(gift){move('gift-result');find('gift-result').focus({preventScroll:true});return;}
      if(revealing)return;
      move('gift-region');
      revealing=true;find('reveal').disabled=true;find('reveal').classList.add('is-opening');
      find('gift-status').textContent=t.opening;
      const eligible=giftIds.filter(id=>config.giftAvailability?.[id]!==false);
      if(!eligible.length){revealing=false;find('reveal').disabled=false;find('gift-status').textContent=t.boxUnavailable;return;}
      let selected=savedGift;
      if(!selected){
        let index;
        if(scope.crypto?.getRandomValues){let n;do{n=scope.crypto.getRandomValues(new Uint32Array(1))[0];}while(n>=Math.floor(4294967296/eligible.length)*eligible.length);index=n%eligible.length;}else{index=Math.floor(Math.random()*eligible.length);}
        selected=giftFromIndex(giftIds.indexOf(eligible[index]));
      }
      scope.setTimeout(()=>{
        gift=selected;savedGift=selected;revealing=false;
        try{scope.localStorage.setItem(storageKey,gift.id);}catch(_){}
        update();find('gift-result').focus({preventScroll:true});
      },scope.matchMedia('(prefers-reduced-motion: reduce)').matches?0:650);
    }
    find('reveal').addEventListener('click',revealGift);
    function review() {
      if(!total(q).complete){move('builder');return;}
      if(!gift){revealGift();return;}
      const summary=find('review-items');summary.replaceChildren();
      products.filter(p=>q[p.id]).forEach(p=>summary.append(el('li','',q[p.id]+' × '+t[p.id])));
      find('review-gift').textContent=t[gift.id]+' · '+t.free;
      find('review-total').textContent=money(total(q).cents);
      find('dialog').showModal();
    }

    find('add').addEventListener('click',async()=>{
      if(submitting)return;
      const button=find('add'),errorNode=find('cart-error');errorNode.hidden=true;
      try {
        if(!config.commerceEnabled || config.parents?.length!==21)throw new Error(t.boxUnavailable);
        if(config.currency!=='USD')throw new Error('Please select USD to purchase this box.');
        if(!gift || config.giftAvailability?.[gift.id]===false)throw new Error(t.giftUnavailable);
        if(products.some(p=>q[p.id] && config.availability?.[p.variantId]===false))throw new Error('A selected pizza is unavailable. Please update your choices.');
        const item=cartItem(q,gift,config.parents);
        let line=1;products.filter(p=>q[p.id]).forEach(p=>{for(let n=0;n<q[p.id];n++)item.properties['Item '+line++]=t[p.id];});
        item.properties['Mystery Gift']=t[gift.id]+' · '+t.free;
        item.properties._currency=scope.Shopify?.currency?.active||'USD';
        item.properties._currency_rate=String(scope.Shopify?.currency?.rate||1);
        submitting=true;button.disabled=true;button.setAttribute('aria-busy','true');button.textContent=t.adding;
        const path=scope.Shopify?.routes?.root||'/';
        const response=await scope.fetch(path+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[item]})});
        const data=await response.json();if(!response.ok)throw new Error(data.description||t.cartError);
        scope.location.assign(path+'cart');
      } catch(error) {errorNode.textContent=error.message||t.cartError;errorNode.hidden=false;}
      finally {submitting=false;button.disabled=false;button.removeAttribute('aria-busy');button.textContent=t.addBox;}
    });

    root.querySelectorAll('[data-hg-next]').forEach(b=>b.addEventListener('click',review));
    root.querySelectorAll('[data-hg-jump-gift]').forEach(b=>b.addEventListener('click',revealGift));
    find('finish').addEventListener('click',review);
    root.querySelectorAll('[data-hg-jump-pizzas]').forEach(b=>b.addEventListener('click',()=>move('builder')));
    root.querySelectorAll('[data-hg-close]').forEach(b=>b.addEventListener('click',()=>find('dialog').close()));
    scope.addEventListener('storage',event=>{
      // Another tab must not expose the surprise or replace an already revealed gift.
      if(!gift&&!revealing&&event.key===storageKey&&giftIds.includes(event.newValue))savedGift=giftFromIndex(giftIds.indexOf(event.newValue));
    });
    update();
  }
  function init(){document.querySelectorAll('[data-halloween-gift]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})(typeof window==='undefined'?globalThis:window);

